import React, { Component } from "react"
import styled from 'styled-components'
import { HashRouter as Router, Route } from 'react-router-dom'
import Index from '../pages/Index'
import Article from '../pages/Article'
import Footer from './Footer'

const StyledApp = styled.div`
direction:rtl;
max-width:1920px;
overflow:hidden;
margin:0 auto;
`
export default class App extends Component {
    render() {
        return (
            <StyledApp>
                <Router basename="/">
                    <main>
                        <Route
                            path="/:section?"
                            component={Index}
                            exact
                        />
                        <Route
                            path="/article/:id"
                            component={Article}
                            exact
                        />
                    </main>
                </Router>
                <Footer />
            </StyledApp >
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/App.jsx